import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { TreeItem as MuiTreeItem, } from "@mui/x-tree-view/TreeItem";
import CustomContent from "./CustomContent";
import TreeItemLabel from "./Label";
import equal from "fast-deep-equal";
const TreeItem = ({ node, titleRender, lazyLoadFn, renderChildren, onExpand, treeItemClasses, ContentComponent, collapseIcon, expandIcon, ...rest }) => {
    const [children, setChildren] = useState(node.children);
    const hasChildren = !!(children && children.length);
    const hasLazyLoad = typeof children != "undefined" && children.length == 0;
    const isMountRef = useRef(false);
    const [loading, setLoading] = useState(false);
    const handleLazyLoad = async () => {
        setLoading(true);
        const nodes = await lazyLoadFn({
            key: node.key,
            children: node.children,
        });
        node.children = nodes;
        setChildren(nodes);
        onExpand(node.key);
        setLoading(false);
    };
    const handleClick = async (event) => {
        if (hasLazyLoad) {
            await handleLazyLoad();
        }
    };
    useEffect(() => {
        if (isMountRef.current) {
            if (node.children != children) {
                if (!equal(node.children, children)) {
                    setChildren(node.children);
                }
            }
        }
    }, [node.children]);
    useEffect(() => {
        isMountRef.current = true;
        return () => {
            isMountRef.current = false;
        };
    }, []);
    return (_jsx(MuiTreeItem, { ContentComponent: ContentComponent ?? CustomContent, nodeId: node.key, disabled: node.disabled, ...rest, classes: treeItemClasses, onClick: handleClick, label: _jsx(TreeItemLabel, { loading: loading, titleRender: titleRender, onLazyLoad: handleLazyLoad, collapseIcon: collapseIcon, expandIcon: expandIcon, node: node }), children: renderChildren(node, children) }, node.key));
};
export default TreeItem;
